/// <reference path="../../_ext/Bases/DialogBase.ts" />

namespace TabAurous.Inventory {
    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    @Serenity.Decorators.maximizable()
    @Serenity.Decorators.responsive()
    export class SKURepricingDialog extends _Ext.TransDialog<SKURepricingRow, any> {
        protected getFormKey() { return SKURepricingForm.formKey; }
        protected getIdProperty() { return SKURepricingRow.idProperty; }
        protected getLocalTextPrefix() { return SKURepricingRow.localTextPrefix; }
        protected getNameProperty() { return SKURepricingRow.nameProperty; }
        protected getService() { return SKURepricingService.baseUrl; }
        protected getDeletePermission() { return SKURepricingRow.deletePermission; }
        protected getInsertPermission() { return SKURepricingRow.insertPermission; }
        protected getUpdatePermission() { return SKURepricingRow.updatePermission; }
        protected get_ExtDialogOptions(): ExtDialogOptions { return Q.deepClone(q.DefaultEntityDialogOptions); }

        public form = new SKURepricingForm(this.idPrefix);
        public Closing: boolean;

        constructor() {
            super();
            //Make grid full width

            q.hideEditorLabel(this.form.Details); 
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 350;
            q.initItemEditor(this, this.form.Details, Config);
            q.initItemEditor(this, this.form.Items, Config);
            //q.hideCaption(this.form.Posted);
            q.SetCategorySixColumn(this.form.TransDate);
            q.SetCategorySixColumn(this.form.VoucherTypeId);
            q.SetCategoryFullWidth(this.form.Details); 

            q.hideEditorLabel(this.form.Items);
            q.HideCategoryLable(this.element);

            //this.form.GenerateSKU.onClick = (e) => {
            //    this.GenSKU(e);
            //};

            (this.form.Details.view as any).onRowCountChanged.subscribe(() => {
            //    this.setItems();

            });
          
        }

        public setItems(details: SKURepricingDetailsRow[]) {
            
            this.form.Items.setData(details);
        }
  

        protected validateBeforeSave() {
            var returnvalue = super.validateBeforeSave();
            var items = this.form.Items.getItems();
            for (var i = 0; i < items.length; i++) {
                var item = items[i];
                if (item.NetAmount == null || item.NetAmount == 0 || item.GrossAmount == null || item.GrossAmount == 0) {
                    q.Alert("Cannot Save!", "Invalid Amount for " + item.ProductCode, 2500, false);
                    returnvalue = false;
                    return returnvalue ;
                }
                if (returnvalue) {
                    var bomdetails = item.BOMDetails;
                    for (var b = 0; b < bomdetails.length; b++) {
                        var bom = bomdetails[b];
                        if (bom.BomRate == null || bom.BomRate <= 0 || bom.BomAmount == null || bom.BomAmount <= 0) {
                            q.Alert("Cannot Save!", "Invalid BOM Rate for " + item.ProductCode, 2500, false);
                            returnvalue = false;
                            return returnvalue;
                        }
                    }
                }
            }
            return returnvalue;
        }

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();
            var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");
            var oldDeleteClick = btnDelete.onClick;
            btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };


            //Edit Click Override
            var btnEdit = Q.first(btns, x => x.cssClass == "edit-button");
            var oldEditClick = btnEdit.onClick;
            btnEdit.onClick = e => { this.confirmBeforeEdit(oldEditClick, e); };


            var postingpermission = Q.Authorization.hasPermission('Inventory:SKURepricing:Posting');
            //Export PDF Button
            btns.push({
                title: 'Post',
                icon: 'las la-check-double',
                cssClass: 'approve-doc-button',
                onClick: () => {
                    var entity = this.entity;
                    entity.AutoPosting = true; delete entity.TransDate;
                 
                    SKURepricingService.Update({ Entity: entity, EntityId: entity.TransId }, response => {
                        if (response.Error == null) {
                            this.dialogClose();
                            Serenity.SubDialogHelper.triggerDataChange(this);
                        }
                    }, { async: false })
                },
                visible: postingpermission

            });




            return btns;
        } 
        // **** Validate Reference of Voucher in Stock Transaction Before Edit. ****
        private confirmBeforeEdit(oldEvt, e) {
            if (this.hasUpdatePermission) {
                let self = this;
                let refid: Stock.StockItemRow;
                Stock.StockItemService.CheckTransaction(
                    { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
                    response => {
                        if (response.Entities != null && response.Entities.length > 0)
                            refid = response.Entities[0];
                    }, { async: false }
                )
                if (refid != null) {
                    if (refid.PartyId != null || refid.PartyId > 0) {
                        q.Alert("Can not Edit!", "This Voucher has been used in transactions", 2500, false);
                        return;
                    }
                } else {
                    Serenity.EditorUtils.setReadonly(this.form.Details.element, false);
                     if (!self.isEditMode())
                        return;
                    self.editClicked = true;

                    self.updateInterface();
                    self.updateTitle();

                }
            }
        }
        // **** Validate Reference of Voucher in Stock Transaction Before Delete. ****
        private confirmBeforeDelete(oldEvt, e) {
            let self = this;
            let refid: Stock.StockItemRow;
            Stock.StockItemService.CheckTransaction(
                { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
                response => {
                    if (response.Entities != null && response.Entities.length > 0)
                        refid = response.Entities[0];
                }, { async: false }
            )
            if (refid != null) {
                if (refid.PartyId != null || refid.PartyId > 0) {
                    q.Alert("Can not Delete!", "This Voucher has been used in transactions", 2500, false);
                    return;
                }
            } else {
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.isConfirmed) {
                        SKURepricingService.Delete(
                            {
                                EntityId: this.entityId
                            }, response => {
                                Serenity.SubDialogHelper.triggerDataChange(self);
                                self.dialogClose();
                                window.setTimeout(() => //Q.notifySuccess(Q.text('Deleted successfully')), 0);
                                    Swal.fire({
                                        icon: 'success',
                                        title: 'Deleted!',
                                        text: 'Voucher Deleted',
                                        showConfirmButton: false,
                                        timer: 1500
                                    })
                                );
                            }
                        );
                    }
                })
            }
        }
    }
}